const DEFAULT_POST_SIGNIN_PATH = '/shift-timeline'

type SigninRedirectState = {
  returnTo: string
}

const getCurrentAppPath = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`

export const createSigninRedirectArgs = () => ({
  state: { returnTo: getCurrentAppPath() } satisfies SigninRedirectState,
})

export const getPostSigninPath = (state: unknown) => {
  if (typeof state !== 'object' || state === null || !('returnTo' in state)) {
    return DEFAULT_POST_SIGNIN_PATH
  }

  const { returnTo } = state
  if (typeof returnTo !== 'string' || !returnTo.startsWith('/')) {
    return DEFAULT_POST_SIGNIN_PATH
  }

  try {
    const returnUrl = new URL(returnTo, window.location.origin)
    if (returnUrl.origin !== window.location.origin || returnUrl.pathname === '/callback') {
      return DEFAULT_POST_SIGNIN_PATH
    }

    return `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`
  } catch {
    return DEFAULT_POST_SIGNIN_PATH
  }
}
